export default __webpack_public_path__ + "img/5638c18dd7bffb880adcbd6fd9d3acd6.svg";